import {
    FETCH_All_SONG_PARENT, GET_SONG_PARENT_DATA, LOAD_SONG_PARENTES, ERROR_LOADING_SONG_PARENTES,
    ERROR_LOADING_SONG_PARENT, LOAD_SONG_PARENT, SAVE_SONG_PARENT, ERROR_ADDING_SONG_PARENT,
    ERROR_SETTING_STATE_SONG_PARENT, SETTING_STATE_SONG_PARENT,
    ERROR_DELETING_SONG_PARENT, DELETING_SONG_PARENT,
    ERROR_UPDATE_SONG_PARENT, UPDATE_SONG_PARENT, EMPTY_SONG_PARENT, EMPTY_SONG_PARENT_WITH_DATA,
    ADD_SONG_PARENT_WITH_SENTFROM
}
    from './Types'

import axios, { post } from 'axios'

export const addSongParentItemWithSentFrom = (item, sentFrom) => dispatch => {

    const songParent = {
        item: item,
        sentFrom: sentFrom
    }
    dispatch({
        type: ADD_SONG_PARENT_WITH_SENTFROM,
        payload: songParent
    })
}


export const fetchAllSongParent = () => dispatch => {

    dispatch({
        type: LOAD_SONG_PARENTES,
        payload: 'loading'
    })

    axios.get('/SongParent/getAllSongParentList')
        .then((res) => {
            dispatch({
                type: FETCH_All_SONG_PARENT,
                payload: res.data
            })
        }
        ).catch((Error) => {
            dispatch({
                type: ERROR_LOADING_SONG_PARENTES,
                payload: Error.message
            })
        })
}

export const getSongParentData = (id) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_SONG_PARENT,
                payload: 'loading'
            })
            const url = "/SongParent/getSongParentDetails"
            const formData = new FormData();
            formData.append('ID', id);
            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: GET_SONG_PARENT_DATA,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_LOADING_SONG_PARENT,
                    payload: Error.message
                })
            })


        })

    }
}

export const saveSongParent = (name, description, imgURL, publish_date,
    audio, promo_with_music, promo_without_music,
    nameInEnglish, descriptionInEnglish,
    videoKeyPromoWithMusic, videoKeyPromoWithoutMusic, featured) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {

            dispatch({
                type: LOAD_SONG_PARENT,
                payload: 'loading'
            })

            const url = '/SongParent/addSongParent';
            const formData = new FormData();
            formData.append('Name', name);
            formData.append('Description', description);
            formData.append('Status', "SUSPENDED");
            formData.append('Image', imgURL);
            formData.append('Publish_Date', publish_date);
            formData.append('Voice', audio);
            formData.append('Promo_Video_With_Music', promo_with_music);
            formData.append('Promo_Video_Without_Music', promo_without_music);
            formData.append('name_in_english', nameInEnglish);
            formData.append('description_in_english', descriptionInEnglish);
            formData.append("videoKeyPromoWithMusic", videoKeyPromoWithMusic);
            formData.append("videoKeyPromoWithoutMusic", videoKeyPromoWithoutMusic);
            formData.append("featured", featured);
            const config = {
                headers: {
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: SAVE_SONG_PARENT,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_ADDING_SONG_PARENT,
                    payload: Error.message
                })
            })
        })


    }
}

export const setStateSongParent = (id, state) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_SONG_PARENT,
                payload: 'loading'
            })

            const url = "/SongParent/setSongParentStatus";
            const formData = new FormData();
            formData.append('ID', id);
            formData.append('Status', state);

            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: SETTING_STATE_SONG_PARENT,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_SETTING_STATE_SONG_PARENT,
                    payload: Error.response.data.message//Error.message
                })
            })
        })

    }
}

export const deleteSongParent = (id) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_SONG_PARENT,
                payload: 'loading'
            })

            const url = "/SongParent/deleteSongParent";
            const formData = new FormData();
            formData.append('ID', id);
            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: DELETING_SONG_PARENT,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_DELETING_SONG_PARENT,
                    payload: Error.message
                })
            })
        })

    }
}

export const updateSongParent = (id, name, description, status, imageUrl, publishDate, audio, promo_with_music, promo_without_music, nameInEnglish, descriptionInEnglish,
    video_key_promo_with_music, video_key_promo_without_music, featured) => {
    return (dispatch, getState, { getFirebase }) => {

        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_SONG_PARENT,
                payload: 'loading'
            })

            const url = "/SongParent/updateSongParent";
            const formData = new FormData();
            formData.append('ID', id);
            formData.append('Name', name);
            formData.append('Description', description);
            formData.append('Image', imageUrl);
            formData.append('Status', "");
            formData.append('Publish_Date', publishDate);
            formData.append('Voice', audio);
            formData.append('Promo_Video_With_Music', promo_with_music);
            formData.append('Promo_Video_Without_Music', promo_without_music);
            formData.append('name_in_english', nameInEnglish);
            formData.append('description_in_english', descriptionInEnglish);
            formData.append('Video_Key_Promo_Video_With_Music', video_key_promo_with_music);
            formData.append('Video_Key_Promo_Video_Without_Music', video_key_promo_without_music);
            formData.append('featured', featured);

            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: UPDATE_SONG_PARENT,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_UPDATE_SONG_PARENT,
                    payload: Error.response.data.message
                })
            })
        })

    }
}


export const emptySongParentWithSongs = () => dispatch => {
    dispatch({
        type: EMPTY_SONG_PARENT_WITH_DATA,
        payload: ""
    })
}

export const emptyError = () => dispatch => {
    dispatch({
        type: EMPTY_SONG_PARENT,
        payload: ""
    })
}
